// Application pages v2 (built by v2/app-page.mjs). Fills the material numbers in any
// [data-oxx-mat="FAMILY:temp|hard"] plate from the same assets/oxx-ic-materials.json the material guide uses,
// so the values are never typed twice. CSS already handles the layout: without this script the plates are empty.
(function () {
  var nodes = document.querySelectorAll('[data-oxx-mat]');
  if (!nodes.length) return;
  var src = document.querySelector('[data-oxx-mat-src]');
  var url = src ? src.getAttribute('data-oxx-mat-src') : null;
  if (!url) return;
  fetch(url, { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (m) {
      var fam = {};
      (m.fam || []).forEach(function (f) { fam[f.code] = f; });
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var parts = (el.getAttribute('data-oxx-mat') || '').split(':');
        var f = fam[parts[0]];
        if (!f) continue;
        if (parts[1] === 'temp' && f.t) el.textContent = f.t.min + ' to +' + f.t.max + ' °C';
        if (parts[1] === 'hard' && f.hard && f.hard.soldStr) el.textContent = f.hard.soldStr;
      }
    })
    .catch(function () { /* leave the plates empty rather than show a wrong number */ });
})();
